module.exports = __webpack_public_path__ + "img/1.7347f5e5.jpg";